module.exports = __webpack_public_path__ + "img/o_kutinchev.019a387b.jpg";